import React from 'react';

import Link from '../../../../library/link/link';
import Toggle from '../../../../library/toggle/toggle';
import PitPassLogo from '../../../pitpass-logo/pitpass-logo';

import styles from './pitpass-filter.scss';

interface PitpassFilterProps {
  isEnabled: boolean;
  onToggle: () => void;
}

function PitpassFilter(props: PitpassFilterProps): React.ReactElement {
  const { isEnabled, onToggle } = props;
  const id = 'pitpassStoresOnly';

  return (
    <div className={styles['container']}>
      <PitPassLogo className={styles['logo']} isPitPassLogoOnly />
      <div>
        <p>
          Our Pit Pass stores offer speedy drive-through fittings when you’ve
          purchased your tires and scheduled an appointment online.
        </p>
        <Link to="/pitpass">Learn more</Link>
      </div>

      <div className={styles['action']}>
        <Toggle ariaLabelledBy={id} isEnabled={isEnabled} onToggle={onToggle} />
      </div>

      <span className={styles['action-label']} id={id}>
        Only show Pit Pass stores
      </span>
    </div>
  );
}

export default PitpassFilter;
